import isMobilePhone from "validator/lib/isMobilePhone";

// We often use this as a default phone number for returns, but it causes problems with places that use it as a unique phone number.
export const DEFAULT_PHONE_NUMBER = "8888888888";

export const isValidNonDefaultPhoneNumber = (phone: string) => {
  try {
    if (phone.includes(DEFAULT_PHONE_NUMBER)) {
      return false;
    }

    if (phone.length < 10) {
      return false;
    }

    if (!isMobilePhone(phone)) {
      return false;
    }
  } catch {
    return false;
  }

  return true;
};
